import { Tabs } from "antd"
import React from "react"

interface MilestoneProjectType {
  id: string
  name: string
}

interface LeadScopeMilestoneProjectTypeTabsProps {
  projectTypes: MilestoneProjectType[]
  activeProjectTypeId: string
  onChange: (projectTypeId: string) => void
}

function LeadScopeMilestoneProjectTypeTabs({
  projectTypes,
  activeProjectTypeId,
  onChange
}: LeadScopeMilestoneProjectTypeTabsProps) {
  if (projectTypes.length <= 1) return null

  return (
    <Tabs
      size={"small"}
      activeKey={activeProjectTypeId}
      items={projectTypes.map(({ id, name }) => ({ key: id, label: name }))}
      onChange={onChange}
    />
  )
}

export { type MilestoneProjectType, LeadScopeMilestoneProjectTypeTabs }
